'use strict';

import * as actionTypes from '../constants/actionTypes';
import * as _ from "lodash";
import * as popupActions from './../actions/A_Popups';
import {getApiConfig} from '../utilities/backend';
import {getChangedEntities} from './../reducers/R_Popups';

const {post} = getApiConfig();
const {get} = getApiConfig();

export function errorBox_ButtonClick(text) {
  return function (dispatch, getState) {
    dispatch({
      type: actionTypes.POPUP_ERROR_BOX_BUTTON_CLICK,
      payload: {
        show: false,
        callback: null
      }
    });
  }
}

export function errorBox_Show(props) {
  return function (dispatch, getState) {
    const state = getState();
    const {errorBox} = state.popups;
    props.title = props.title || 'Error';
    props.rightButtonText = props.rightButtonText || 'OK';
    props.isRightButtonVisible = props.isRightButtonVisible === undefined ? true : props.isRightButtonVisible;
    _.merge(errorBox, props);
    errorBox.show = true;
    errorBox.callback = props.callback;
    dispatch({
      type: actionTypes.POPUP_ERROR_BOX,
      payload: errorBox
    });
  }
}

export function loadingDialog_show(show, title, message, useIntl = false) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: actionTypes.POPUP_IN_PROGRESS,
        payload: {
          show,
          title,
          message,
          useIntl
        }
      });
      window.setTimeout(resolve, 500);
    }).catch(console.error);
  }
}

export function messageBoxEx_Show(show, type, title, message, buttons) {
  if (typeof show !== 'boolean') {
    show = false;
  }
  return function (dispatch) {
    return new Promise((resolve) => {
      dispatch({
        type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
        payload: {
          visible: show || false,
          title: title || '',
          message: message || '',
          type: type || 'system',
          uibuttons: buttons || [{
            text: 'OK',
            onClick: () => {
              dispatch(messageBox_Show()); //reset to default props (not visible by default)
              resolve();
            }
          }]
        }
      });
    }).catch(console.error);
  }
}

export function messageBox_Show(show, type, title, message, buttons) {
  if (typeof show !== 'boolean') {
    show = false;
  }
  return function (dispatch) {
    return new Promise((resolve) => {
      dispatch({
        type: actionTypes.POPUP_MESSAGE_BOX_SHOW,
        payload: {
          visible: show || false,
          title: title || '',
          message: message || '',
          type: type || 'system',
          uibuttons: buttons || [{
            text: 'OK',
            onClick: () => {
              dispatch(messageBox_Show()); //reset to default props (not visible by default)
              resolve();
            }
          }]
        }
      });
    }).catch(console.error);
  }
}

export function messageBoxComponent_Show(show, type, title, message, buttons) {
  if (typeof show !== 'boolean') {
    show = false;
  }
  return function (dispatch) {
    return new Promise((resolve) => {
      dispatch({
        type: actionTypes.POPUP_MESSAGE_BOX_COMPONENT_SHOW,
        payload: {
          visible: show || false,
          title: title || '',
          message: message || '',
          type: type || 'system',
          uibuttons: buttons || [{
            text: 'OK',
            onClick: () => {
              dispatch(messageBox_Show()); //reset to default props (not visible by default)
              resolve();
            }
          }]
        }
      });
    }).catch(console.error);
  }
}

export function assignSalesPerson(job, show) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.POPUP_ASSIGN_SALES_PERSON,
      payload: {
        visible: show,
        job
      }
    });
  }
}

export function newEntitySetMasterProfile(data) {
  return (dispatch, getState) => {
    const state = getState();

    const id = +state.popups.assignSalesPerson.get('selectedId');
    if (!id) {
      dispatch(popupActions.messageBox_Show(true, 'error', 'Error', 'Select a fabricator.'));
      return;
    }

    return dispatch({
      type: actionTypes.POPUP_NEW_ENTITY_SET_MASTER_PROFILE,
      payload: {
        id,
        ...data
      }
    })
  }
}

/**
 *
 * @param show
 * @param popupAction {int}, comes from AssignSalesPersonPopup.actions
 * @param data
 * @returns {function(*): *}
 */
export function showFabricatorsPopup(show, popupAction, data) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_ASSIGN_SALES_PERSON,
    payload: {
      visible: show,
      popupAction,
      data
    }
  })
}

export function showJobBoardExport(show = false) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_JOB_BOARD_EXPORT_SHOW,
    payload: {
      show
    }
  });
}

export function showAssignEntityPopup(config) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_ASSIGN_ENTITY,
    payload: {...config}
  })
}

export function showFabricatorsExportPopup(config) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_SHOW_FABRICATORS_EXPORT_POPUP,
    payload: {...config}
  });
};

export function showClonePricingPresetsIntoPopup(config) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_SHOW_CLONE_PRICING_PRESETS_INTO_POPUP,
    payload: {...config}
  });
};

export function showImportFabricatorPopup(show) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_IMPORT_FABRICATOR,
    payload: {visible: show}
  });
}

export function assignEntityPopupResetStatus() {
  return dispatch => dispatch({
    type: actionTypes.POPUP_ASSIGN_ENTITY_RESET_STATUS
  })
}

export function assignEntityPopupCheckName(itemId, checked) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_ASSIGN_ENTITY_CHECK_NAME,
    payload: {itemId, checked}
  })
}

export function assignMultipleEntitiesProperty(propName, value) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_ASSIGN_MULTIPLE_ENTITIES_CHECK,
    payload: {propName, value}
  })
}

export function assignEntityPopupCheckIsLicensedAdmin(itemId, checked) {
  return dispatch => dispatch({
    type: actionTypes.POPUP_ASSIGN_ENTITY_CHECK_LICENSED_ADMIN,
    payload: {itemId, checked}
  })
}


export function assignEntityPopupSave(storePath) {
  return (dispatch, getState) => {
    const state = getState();
    const {popups} = state;
    const changedEntities = getChangedEntities(popups);

    const saveAction = popups.assignEntity.get('saveAction');
    if (saveAction) {
      const selectedEntities = changedEntities.map(_ => _.id);
      loadingDialog_show(true, 'Saving...', 'Please wait while we save associations...')(dispatch);
      saveAction(selectedEntities)
        .then(() => {
          loadingDialog_show(false)(dispatch);
          dispatch({type: actionTypes.POPUP_ASSIGN_ENTITY_SAVED});
        })
      return ;
    }

    if (!storePath) {
      loadingDialog_show(true, 'Saving...', 'Please wait while we save associations...')(dispatch);
      dispatch({type: actionTypes.POPUP_ASSIGN_ENTITY_SAVING});
    }

    const data = {
      entityId: popups.assignEntity.get('entityId'),
      entityType: popups.assignEntity.get('entityType'),
      attachTo: changedEntities.map(_ => ({
        entityId: _.id,
        isLicensedAdmin: _.isLicensedAdmin,
        isAssociated: _.isAssociated
      }))
    };

    if (storePath) {
      dispatch({
        type: actionTypes.POPUP_ASSIGN_ENTITY_SAVE_TO_STORE,
        payload: {
          ...data,
          storePath
        }
      })
    } else {
      const {post} = getApiConfig('Users/AssignEntity');
      post(data)
        .then(answer => {
          dispatch({type: actionTypes.POPUP_ASSIGN_ENTITY_SAVED});
          loadingDialog_show(false, 'Saving...', 'Please wait while we save associations...')(dispatch);
        });
    }
  }
}

export function showChooseEmailTemplatesPopup(show) {

  (typeof show !== 'boolean') && (show = false);

  return function (dispatch) {
    dispatch({
      type: actionTypes.POPUP_CHOOSE_EMAIL_TEMPLATES_BOX_SHOW,
      payload: {
        visible: show || false
      }
    });
  }
}

export function chooseEmailTemplate(template) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.POPUP_CHOOSE_EMAIL_TEMPLATE,
      payload: {
        template
      }
    });
    dispatch({
      type: actionTypes.POPUP_CHOOSE_EMAIL_TEMPLATES_BOX_SHOW,
      payload: {
        visible: false
      }
    });
  }
}

export function filterGroupVisualStylePopupItemSelected(style) {
  return dispatch => dispatch({type: actionTypes.POPUP_FILTER_GROUP_VISUAL_STYLE_SELECTED, payload: style});
}

export function filterGroupVisualStylePopup(show, style) {
  return dispatch => dispatch({type: actionTypes.POPUP_FILTER_GROUP_VISUAL_STYLE, payload: {show, style}});
}

export function toggle_modal(visible = false, message = '', buttons) {
  return function (dispatch) {
    return new Promise((resolve) => {
      dispatch({
        type: actionTypes.POPUP_TOGGLE_MODAL,
        payload: {
          visible,
          message,
          buttons: buttons || [{
            color: 'blue',
            text: 'OK',
            onClick: () => {
              dispatch(toggle_modal(false)); //reset to default props (not visible by default)
              resolve();
            }
          }]
        }
      });
    }).catch(console.error);
  }
}

export const showPermissionsPopup = (permissionsPopupState) => ({
  type: actionTypes.POPUP_SHOW_PERMISSIONS_POPUP,
  payload: { permissionsPopupState }
});

export const setResetPasswordPopup = (resetPasswordPopupState) => ({
  type: actionTypes.POPUP_SET_RESET_PASSWORD_POPUP_STATE,
  payload: { resetPasswordPopupState }
});

export const setDocuSignPopupState = (docuSignPopupState) => ({
  type: actionTypes.POPUP_SET_DOCUSIGN_POPUP_STATE,
  payload: { docuSignPopupState }
});

export const setFingerSignaturePopupState = (fingerSignaturePopupState) => ({
  type: actionTypes.POPUP_SET_FINGER_SIGNATURE_POPUP_STATE,
  payload: { fingerSignaturePopupState }
});

export const setQuestionPopupState = (questionPopupState) => ({
  type: actionTypes.POPUP_SET_QUESTION_POPUP_STATE,
  payload: { questionPopupState }
});

export const setShowJobPaymentPopup = (showJobPaymentPopup, job) => ({
  type: actionTypes.JOB_BOARD_SHOW_PAYMENT_POPUP,
  payload: {showJobPaymentPopup, job}
});

export const setShowJobEditPopup = (showJobEditPopup, job) => ({
  type: actionTypes.JOB_BOARD_SHOW_EDIT_POPUP,
  payload: {showJobEditPopup, job}
});

export const setShowJobPurchaseOrderPopup = (showJobPurchaseOrderPopup, job, purchaseOrderStep) => ({
  type: actionTypes.JOB_BOARD_SHOW_PURCHASE_ORDER_POPUP,
  payload: {showJobPurchaseOrderPopup, job, purchaseOrderStep}
});

export const setUiPopupState = (uiPopupState) => ({
  type: actionTypes.SET_UI_POPUP_STATE,
  payload: {uiPopupState}
});

export const setSignaturePopupState = (signaturePadPopup) => ({
  type: actionTypes.POPUP_SET_SIGNATURE_POPUP_STATE,
  payload: signaturePadPopup
});
